var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3713 9.85645H11.651L11.3956 9.6202C12.2893 8.62269 12.8273 7.3277 12.8273 5.91895C12.8273 2.7777 10.1738 0.231445 6.9002 0.231445C3.62664 0.231445 0.973145 2.7777 0.973145 5.91895C0.973145 9.06019 3.62664 11.6064 6.9002 11.6064C8.36829 11.6064 9.71783 11.0902 10.7573 10.2327L11.0035 10.4777V11.1689L15.5628 15.5352L16.9215 14.2314L12.3713 9.85645ZM6.9002 9.85645C4.62968 9.85645 2.79685 8.0977 2.79685 5.91895C2.79685 3.7402 4.62968 1.98145 6.9002 1.98145C9.17072 1.98145 11.0035 3.7402 11.0035 5.91895C11.0035 8.0977 9.17072 9.85645 6.9002 9.85645Z",
    fill: "#222222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.660ef451c865fde923e0c8084efbc3ee.svg";
export { ForwardRef as ReactComponent };